import "../assets/styles/Inplay.css";
import InPlayCard from "../components/InPlayCard";
import Bet_slip from "../components/Bet_slip";
import Mobiletabs from "../components/Tabs/Mobiletabs";

const Today = () => {

  return (
    <div>
      <div className="Bars inplay">
        <div className="btn-box">
          <div className="inner-box">
            <Mobiletabs />
             <InPlayCard />
          </div>
        </div>
        <Bet_slip />
      </div>
    </div>
  );
};

export default Today;
